export const desktopMenuBreakpoint = '(min-width: 769px)';
export const desktopSettingsMenuBreakpoint = '(min-width: 992px)';
export const xsBreakpoint = '(max-width: 576px)';
export const floorPlanRightSidebarBreakpoint = '(max-width: 1400px)';
export const shortHeightBreakpoint = '(max-height: 700px)';
// Primary pointer is touch (phones/tablets) — mice and trackpads report `fine`,
// so touch-capable laptops driven by a mouse are correctly excluded.
export const touchPointerBreakpoint = '(pointer: coarse)';
